import type { ConnectorOAuthConfig } from "./types";

export function requestedOAuthScopes(
  oauth: ConnectorOAuthConfig,
  configuration: Record<string, string>,
  requestedScopes: string[] | null
) {
  return requestedScopes?.length
    ? requestedScopes
    : "scopes" in oauth
      ? oauth.scopes(configuration)
      : [];
}
